import { render, staticRenderFns } from "./MenusComandero.vue?vue&type=template&id=6534e7cb&scoped=true"
import script from "./MenusComandero.vue?vue&type=script&lang=js"
export * from "./MenusComandero.vue?vue&type=script&lang=js"
import style0 from "./MenusComandero.vue?vue&type=style&index=0&id=6534e7cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6534e7cb",
  null
  
)

export default component.exports